import { render } from "./EntrySlider.vue?vue&type=template&id=72bdbc9f"
import script from "./EntrySlider.vue?vue&type=script&lang=ts"
export * from "./EntrySlider.vue?vue&type=script&lang=ts"

import "./EntrySlider.vue?vue&type=style&index=0&id=72bdbc9f&lang=scss"
script.render = render

export default script